export const userService = {
  login,
  logout,
};

function login(username, password, serverIP) {
  const requestOptions = {
    method: "POST",
    body: "login=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  return fetch(serverIP, requestOptions)
    .then(handleResponse)
    .then((data) => {
      /* if (data.logged && data.logged === 1) { */
      if (data.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (localStorage.getItem("login")) {
          //parse ip from login address
          let login = JSON.parse(localStorage.getItem("login"));

          data.appurl = login.url;
        }
        sessionStorage.setItem("user", JSON.stringify(data));
      }

      return data;
    });
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    let roles = [];

    if (data.hasOwnProperty("roles")) {
      if (data.roles.includes("EC_ADMIN")) {
        roles[0] = "EC_ADMIN";
      } else if (data.roles.includes("EC_SERVICE")) {
        roles[0] = "EC_SERVICE";
      } else if (data.roles.includes("EC_USER")) {
        roles[0] = "EC_USER";
      }

      if (data.roles.includes("EVC_ADMIN")) {
        roles[1] = "EVC_ADMIN";
      } else if (data.roles.includes("EVC_SERVICE")) {
        roles[1] = "EVC_SERVICE";
      } else if (data.roles.includes("EVC_USER")) {
        roles[1] = "EVC_USER";
      }

      // Zpětná kompatibilita
    } else if (data.hasOwnProperty("role")) {
      if (data.role === "admin") {
        roles[0] = "EC_ADMIN";
      } else if (data.role === "service") {
        roles[0] = "EC_SERVICE";
      } else if (data.role === "user") {
        roles[0] = "EC_USER";
      }
    }

    data.roles = [];

    for (let index = 0; index < roles.length; index++) {
      data.roles[index] = roles[index];
    }

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
      }

      return Promise.reject(response.status);
    }
    return data;
  });
}

function logout() {
  sessionStorage.removeItem("user");

  /*   
  sessionStorage.removeItem("projectName");
  sessionStorage.removeItem("objectName");
  sessionStorage.removeItem("serialNumber"); 
  */
}
